import styled from '@emotion/styled';
import { useEffect, useState } from 'react';
import Typography from '~/modules/Elements/AKUI/Primitives/Typography';
import RemoteMicClient from '~/modules/RemoteMic/Network/Client';
import NumericInput from '~/routes/RemoteMic/Components/NumericInput';

function RemoteInputLag() {
  const [currentValue, setCurrentValue] = useState(0);
  const [isLoading, setIsLoading] = useState(false);

  useEffect(() => {
    setIsLoading(true);
    RemoteMicClient.getGameInputLag()
      .then(({ value }) => setCurrentValue(value))
      .catch((e) => console.warn(e))
      .finally(() => setIsLoading(false));
  }, []);

  const changeValue = (newValue: number) => {
    setIsLoading(true);
    RemoteMicClient.setGameInputLag(newValue)
      .then(({ value }) => setCurrentValue(value))
      .catch((e) => console.warn(e))
      .finally(() => setIsLoading(false));
  };

  return (
    <Stack>
      <SectionTitle>Adjust game input lag</SectionTitle>
      <NumericInput
        value={currentValue}
        onChange={changeValue}
        disabled={isLoading}
        unit="ms"
        data-test="game-input-lag"
      />
      <HelpText>If the sound is not synchronised with the lyrics, use this to compensate it.</HelpText>
    </Stack>
  );
}

export default RemoteInputLag;

const Stack = styled.div`
  display: flex;
  flex-direction: column;
  gap: 10px;
`;

const SectionTitle = styled.h3`
  margin: 0;
  color: var(--walky-ink);
  font-size: 16px;
  font-weight: 900;
`;

const HelpText = styled(Typography)`
  color: var(--walky-muted);
  font-size: 12px;
  line-height: 1.35;
`;
